import { SketchPicker } from "react-color";
import { TextBox } from "store/features/memeGenerator/types";
import { Mode } from "../../types";
import { ColorPickerButtonContainer } from "./ColorPickerButtonContainer";
import { useColorPickerButton } from "./useColorPickerButton";
import { stopPropagation } from "client/utils/stopPropagation";

export interface ColorPickerButtonProps {
    mode: Mode;
    textBox: TextBox;
}

export const ColorPickerButton = ({ mode, textBox }: ColorPickerButtonProps) => {
    const { isOpen, isActive, toggle, parentRef, color, onChange } = useColorPickerButton(textBox, mode);
    return (
        <ColorPickerButtonContainer
            isActive={isActive}
            onClick={toggle}
            ref={parentRef}
            absoluteElement={
                isOpen && (
                    <div className={`absolute top-full left-full`} onClick={stopPropagation()}>
                        <SketchPicker color={color} onChange={onChange} disableAlpha={true} />
                    </div>
                )
            }
        />
    );
};
